(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complementary-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('trd-accessory-kit')) {
  customElements.define('trd-accessory-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const wrapper = this.closest('.product--outer');
      const form = wrapper?.querySelector('form[data-product-form]');
      const anchor = form?.querySelector('.product-form--atc');
      if (!anchor) return;
      this.ready = true;
      const oldBlock = this.closest('.product-block--complementary_products');
      anchor.before(this);
      if (oldBlock) oldBlock.hidden = true;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      const status = this.querySelector('[data-extra-status]');
      const selected = () => [...this.querySelectorAll('[data-extra]:checked:not(:disabled)')];
      const update = () => {
        this.querySelectorAll('[data-extra-variant]').forEach(select => {
          const input = select.closest('article').querySelector('[data-extra]');
          input.value = select.value;
          input.dataset.price = select.selectedOptions[0]?.dataset.price || '0';
        });
        this.querySelector('[data-extra-total]').textContent = money.format(selected().reduce((sum,input)=>sum+Number(input.dataset.price),0)/100);
        const express = form.querySelector('.shopify-payment-button');
        if (express) express.hidden = selected().length > 0;
        status.textContent = '';
      };
      this.addEventListener('change',update);
      update();
      form.addEventListener('submit', async event => {
        const extras = selected();
        if (!extras.length) return;
        const data = new FormData(form);
        const id = Number(data.get('id'));
        if (!id) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        this.busy = true;
        const button = form.querySelector('[data-product-atc]');
        if (button) button.disabled = true;
        status.textContent = this.dataset.adding;
        const main = {id,quantity:Math.max(1,Number(data.get('quantity'))||1),properties:{}};
        for (const [key,value] of data) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) main.properties[match[1]] = value;
        }
        if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js', {
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[main,...extras.map(input=>({id:Number(input.value),quantity:1}))]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
          this.busy = false;
          if (button) button.disabled = false;
        }
      },true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-acemate-gift-only"] && !Shopify.designMode) return;
  try {
    if (!window.trdKiteGiftSubmitInstalled) {
    window.trdKiteGiftSubmitInstalled = true;
    // Gift speed fix: add the robot and its Kite free gift in one request, using Kite's own
    // line properties so Kite recognises the gift and does not add a second one on the cart page.
    const kiteGiftsFor = variantId => {
      try {
        const offers = (window.gfg && window.gfg.settings && window.gfg.settings.freeGiftsV2) || [];
        const now = Date.now();
        for (const offer of offers) {
          if (!offer || !offer.isEnabled || offer.isTestMode || !offer.advancedSettings || !offer.advancedSettings.isAutoAdd) continue;
          const schedule = offer.campaignScheduleData || {};
          if (schedule.startDateTime && now < Date.parse(schedule.startDateTime)) continue;
          if (schedule.endDateTime && now >= Date.parse(schedule.endDateTime)) continue;
          const segments = (offer.segmentsData && offer.segmentsData.segmentsList) || [];
          for (const segment of segments) {
            const buyRules = ((segment.buyXRulesData && segment.buyXRulesData.rulesList) || []).filter(rule => rule.ruleType === 'products' && rule.ruleValue && rule.ruleValue.operatorType === 'include');
            const triggered = buyRules.some(rule => (rule.ruleValue.value || []).some(product => (product.variants || []).some(variant => Number(variant.variantId) === variantId)));
            if (!triggered) continue;
            const giftIds = [];
            ((segment.getYRulesData && segment.getYRulesData.rulesList) || []).forEach(rule => {
              (rule.ruleValue && rule.ruleValue.value || []).forEach(product => {
                (product.variants || []).forEach(variant => {
                  const id = Number(variant.variantId);
                  if (id && variant.availableForSale !== false && !giftIds.includes(id)) giftIds.push(id);
                });
              });
            });
            if (!giftIds.length) continue;
            return giftIds.map(id => ({ id, quantity: 1, properties: { _free_product: 'true', _rule_id: String(segment.segmentId), _kite_promo_name: String(offer.title) } }));
          }
        }
      } catch (_) {}
      return null;
    };
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const offer = form.querySelector('[data-trd-kite-submit]');
      if (!offer) return;
      const data = new FormData(form);
      const mainId = Number(data.get('id'));
      if (!mainId || data.get('selling_plan')) return;
      const gifts = kiteGiftsFor(mainId);
      if (!gifts) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.trdKiteBusy === 'true') return;
      const quantity = Number(data.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) {
        offer.textContent = offer.dataset.error;
        offer.hidden = false;
        return;
      }
      const cartUrl = offer.dataset.cartUrl;
      const request = async (suffix, body) => {
        const response = await fetch(cartUrl + suffix, {
          method: body ? 'POST' : 'GET',
          headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
          ...(body ? { body: JSON.stringify(body) } : {})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || offer.dataset.error);
        return result;
      };
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const disabledBefore = buttons.map(button => button.disabled);
      form.dataset.trdKiteBusy = 'true';
      form.setAttribute('aria-busy', 'true');
      buttons.forEach(button => button.disabled = true);
      offer.hidden = true;
      try {
        const cart = await request('.js');
        const properties = {};
        for (const [key, value] of data.entries()) {
          if (typeof value === 'string' && key.startsWith('properties[') && key.endsWith(']')) properties[key.slice(11, -1)] = value;
        }
        const items = [{ id: mainId, quantity, properties }];
        const seen = new Set([mainId, ...gifts.map(gift => gift.id)]);
        for (const input of form.querySelectorAll('trd-accessory-kit [data-extra]:checked:not(:disabled)')) {
          const id = Number(input.value);
          if (!Number.isSafeInteger(id) || id < 1 || seen.has(id)) continue;
          seen.add(id);
          items.push({ id, quantity: 1 });
        }
        const newGifts = gifts.filter(gift => !cart.items.some(line => line.variant_id === gift.id));
        items.push(...newGifts);
        await request('/add.js', { items });
        if (newGifts.length) {
          let after = await request('.js');
          const unpaid = () => newGifts.every(gift => after.items.some(line => line.variant_id === gift.id && line.final_line_price === 0));
          for (let attempt = 0; attempt < 3 && !unpaid(); attempt++) {
            await new Promise(resolve => setTimeout(resolve, 400));
            after = await request('.js');
          }
          if (!unpaid()) {
            // Never leave a charged gift behind: remove our gift lines and let Kite add its own on the cart page.
            const updates = {};
            after.items.forEach(line => {
              if (newGifts.some(gift => gift.id === line.variant_id) && line.final_line_price > 0 && line.properties && line.properties._rule_id) updates[line.key] = 0;
            });
            if (Object.keys(updates).length) await request('/update.js', { updates });
          }
        }
        window.location.assign(cartUrl);
      } catch (failure) {
        offer.textContent = failure.message || offer.dataset.error;
        offer.hidden = false;
        form.dataset.trdKiteBusy = 'false';
        form.removeAttribute('aria-busy');
        buttons.forEach((button, index) => button.disabled = disabledBefore[index]);
      }
    }, true);
  }
  (() => {
    const root = document.querySelector('[data-trd-acemate-only]');
    if (!root || root.dataset.installed) return;
    root.dataset.installed = 'true';
    const form = root.closest('form');
    if (!form) return;
    const giftRules = {
      50385477501142: { group: 'acemate', robots: [48239014281430, 50520501158102] },
      67563287314646: { group: 'acemate', robots: [48239014281430, 50520501158102] },
      50385477599446: { group: 'acemate', robots: [48239014281430, 50520501158102] },
      50389667709142: { group: 'terramow', robot: 47564164137174 },
      50389591752918: { group: 'chasing', robot: 47739539259606 },
      50389591785686: { group: 'chasing', robot: 47736568643798 },
      50413903610070: { group: 'chasing', robots: [47739899805910, 47739899838678, 47739899871446] },
      50408891318486: { group: 'aceiilab', robot: 50330081657046 },
      50520526880982: { group: 'chasing', robot: 50232502911190 },
      67692357026006: { group: 'pongbot-nova', robot: 67675557658838 },
      67692357058774: { group: 'pongbot-nova', robot: 67675557658838 },
      67692357091542: { group: 'pongbot-tt', robots: [67675557888214, 67675558019286, 67675563557078] },
      67692357124310: { group: 'pongbot-pace-cover', robot: 67675565949142 },
      67692365316310: { group: 'pongbot-pace-balls', robot: 67675565949142 },
      67846713770198: { group: 'sunseeker-garage', robots: [67846700368086, 67846701187286, 67846700204246, 67846700597462, 67846700302550, 67846700630230, 67846701056214] },
      67846713802966: { group: 'sunseeker-blades', robots: [67846700564694, 67846701711574, 67846700302550, 67846700630230, 67846701056214] }
    };
    let running;
    let allowCheckout = false;
    let queued;
    const request = async (suffix, body) => {
      const response = await fetch(root.dataset.cartUrl + suffix, {
        method: body ? 'POST' : 'GET',
        headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error(root.dataset.error);
      return response.json();
    };
    const check = () => {
      if (running) return running;
      running = (async () => {
        try {
          const cart = await request('.js');
          const kept = new Set();
          const updates = {};
          cart.items.forEach(item => {
            const rule = giftRules[item.variant_id];
            if (!rule) return;
            const hasRobot = cart.items.some(robot => (rule.robots || [rule.robot]).includes(robot.variant_id) && robot.quantity > 0);
            if (hasRobot && !kept.has(rule.group) && item.quantity === 1 && item.final_line_price === 0) kept.add(rule.group);
            else updates[item.key] = 0;
          });
          if (Object.keys(updates).length) {
            const note = form.querySelector('[name="note"]');
            await request('/update.js', { updates, ...(note ? { note: note.value } : {}) });
            try { sessionStorage.setItem('trd-acemate-gift-removed', '1'); } catch (_) {}
            window.location.reload();
            return false;
          }
          return true;
        } catch (_) {
          root.hidden = false;
          root.querySelector('[role="status"]').textContent = root.dataset.error;
          return false;
        } finally { running = null; }
      })();
      return running;
    };
    const guard = async event => {
      if (allowCheckout) return;
      const button = event.type === 'click' ? event.target.closest('button[name="checkout"]') : event.submitter;
      if (!button || button.form !== form || button.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (await check()) { allowCheckout = true; form.requestSubmit(button); }
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
    const items = form.querySelector('.cartitems--container');
    if (items) new MutationObserver(() => {
      clearTimeout(queued);
      queued = setTimeout(check, 400);
    }).observe(items, { childList: true, subtree: true });
    try {
      if (sessionStorage.getItem('trd-acemate-gift-removed')) {
        root.hidden = false;
        root.querySelector('[role="status"]').textContent = root.dataset.removed;
        sessionStorage.removeItem('trd-acemate-gift-removed');
      }
    } catch (_) {}
    check();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-acemate-gift-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-acemate-addon-id]');
  if (!button) return;
  const status = button.closest('.trd-acemate-addons').querySelector('.trd-acemate-addons__status');
  button.disabled = true;
  status.textContent = 'Adding accessory to cart…';
  try {
    const response = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: Number(button.dataset.acemateAddonId), quantity: 1})});
    if (!response.ok) throw new Error('The accessory could not be added. Please try again.');
    status.textContent = 'Accessory added. Now add the Acemate system to cart below.';
    button.textContent = '✓';
  } catch (error) {status.textContent = error.message; button.disabled = false;}
});

if (!window.trdAcematePickerInstalled) {
  window.trdAcematePickerInstalled = true;
  const ROBOTS = [48239014281430, 50520501158102];
  const GIFTS = [50385477501142, 67563287314646];
  const ERROR = 'Sorry, we could not add your free gift. Please try again or contact us.';
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches || !input.matches('[data-trd-acemate-picker] input[name="trd-acemate-gift"]')) return;
    const picker = input.closest('[data-trd-acemate-picker]');
    picker.classList.remove('is-error');
    picker.querySelector('[data-trd-acemate-msg]').hidden = true;
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const picker = form.querySelector('[data-trd-acemate-picker]');
    if (!picker) return;
    const data = new FormData(form);
    const mainId = Number(data.get('id'));
    if (!ROBOTS.includes(mainId)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.trdAcemateBusy === 'true') return;
    const msg = picker.querySelector('[data-trd-acemate-msg]');
    const choice = picker.querySelector('input[name="trd-acemate-gift"]:checked');
    if (!choice) {
      msg.textContent = 'Please choose your free gift above, then add to cart.';
      msg.hidden = false;
      picker.classList.add('is-error');
      picker.scrollIntoView({block: 'center', behavior: 'smooth'});
      picker.querySelector('input[name="trd-acemate-gift"]').focus({preventScroll: true});
      return;
    }
    const giftId = Number(choice.value);
    const quantity = Math.max(1, parseInt(data.get('quantity') || '1', 10) || 1);
    const cartUrl = picker.dataset.cartUrl;
    const buttons = [...form.querySelectorAll('button[type="submit"]')];
    const disabledBefore = buttons.map(button => button.disabled);
    form.dataset.trdAcemateBusy = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; button.classList.add('processing'); });
    msg.hidden = true;
    const getCart = async () => {
      const response = await fetch(cartUrl + '.js', {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error(ERROR);
      return response.json();
    };
    const post = async (path, body) => {
      const response = await fetch(cartUrl + path, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || ERROR);
      return result;
    };
    const hasChosenGift = cart => cart.items.some(item => item.variant_id === giftId && item.final_line_price === 0);
    try {
      await post('/add.js', {items: [{id: mainId, quantity}]});
      let cart = await getCart();
      for (const item of cart.items) {
        if (GIFTS.includes(item.variant_id) && item.variant_id !== giftId) await post('/change.js', {id: item.key, quantity: 0});
      }
      cart = await getCart();
      if (mainId === 48239014281430 && !cart.items.some(item => item.variant_id === giftId)) { await post('/add.js', {items: [{id: giftId, quantity: 1}]}); cart = await getCart(); }
      let claimed = false;
      for (let attempt = 0; attempt < 30 && !hasChosenGift(cart); attempt++) {
        if (!claimed) {
          const row = [...form.querySelectorAll('.gfgFGv2-row-unlocked')].find(r => (r.textContent || '').includes(choice.dataset.kiteMatch));
          const claim = row && row.querySelector('.gfgFGv2-btn-add:not([disabled])');
          if (claim) { claim.click(); claimed = true; }
        }
        await sleep(500);
        cart = await getCart();
      }
      if (!hasChosenGift(cart)) throw new Error(ERROR);
      window.location.assign(cartUrl);
    } catch (failure) {
      msg.textContent = failure.message || ERROR;
      msg.hidden = false;
      form.dataset.trdAcemateBusy = 'false';
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => { button.disabled = disabledBefore[index]; button.classList.remove('processing'); });
    }
  }, true);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-yarbo-cart-gift"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-trd-cart-gift]');
    if (!root || root.dataset.installed) return;
    root.dataset.installed = 'true';
    const form = root.closest('form');
    const status = root.querySelector('[data-cart-gift-status]');
    const retry = root.querySelector('[data-cart-gift-retry]');
    const giftIds = [50382698741974, 50382700085462];
    const eligibility = {
  "50382698741974": [
    47259631845590,
    47259647410390,
    48360806580438,
    48360810938582,
    50409005121750,
    50409143730390,
    50409143828694,
    50409143861462,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ],
  "50382700085462": [
    47259649442006,
    48360804450518,
    48360806744278,
    48360811528406,
    50409005482198,
    50409005973718,
    50409143795926,
    50409145041110,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ]
};
    let running = null;
    let allowCheckout = false;
    let queued = null;
    let pendingPreference;
    let needsReload = false;
    const optOutKey = '_trd_yarbo_gift_opt_out';
    const request = async (suffix, body) => {
      const response = await fetch(root.dataset.cartUrl + suffix, {
        method: body ? 'POST' : 'GET',
        headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(root.dataset.error);
      return result;
    };
    const planGift = (cart, preferred, active) => {
      const allowed = active ? giftIds.filter(id => cart.items.some(item => eligibility[id].includes(item.variant_id))) : [];
      const managed = cart.items.filter(item => giftIds.includes(item.variant_id) && item.properties && item.properties._trd_gift_for);
      const existing = cart.items.find(item => allowed.includes(item.variant_id) && (!preferred || item.variant_id === preferred) && (managed.includes(item) || item.final_line_price === 0));
      const optedOut = preferred === 0 || (preferred === undefined && cart.attributes && cart.attributes[optOutKey] === '1');
      const chosen = optedOut ? undefined : (existing ? existing.variant_id : (allowed.includes(preferred) ? preferred : allowed[0]));
      const updates = {};
      managed.forEach(item => {
        const wanted = !optedOut && item === existing ? 1 : 0;
        if (item.quantity !== wanted) updates[item.key] = wanted;
      });
      const system = chosen && cart.items.find(item => eligibility[chosen].includes(item.variant_id));
      return { chosen, updates, optedOut, allowed, add: chosen && !existing ? { id: chosen, quantity: 1, properties: { _trd_gift_for: String(system.variant_id) } } : null };
    };
    const reconcile = preferred => {
      if (running) {
        if (preferred !== undefined) pendingPreference = preferred;
        return running;
      }
      running = (async () => {
        const checkoutButtons = [...form.querySelectorAll('button[name="checkout"]')];
        const disabledBefore = checkoutButtons.map(button => button.disabled);
        const giftInputs = [...root.querySelectorAll('input[name="trd_cart_gift_choice"]')];
        form.setAttribute('data-trd-cart-checking', '');
        root.setAttribute('aria-busy', 'true');
        checkoutButtons.forEach(button => button.disabled = true);
        giftInputs.forEach(input => input.disabled = true);
        retry.hidden = true;
        status.textContent = root.dataset.checking;
        try {
          const cart = await request('.js');
          const plan = planGift(cart, preferred, Date.now() <= Date.parse('2026-12-01T04:59:59Z'));
          let changed = false;
          const attributeValue = plan.optedOut && plan.allowed.length ? '1' : '';
          const attributeChanged = (cart.attributes?.[optOutKey] || '') !== attributeValue;
          if (Object.keys(plan.updates).length || attributeChanged) {
            await request('/update.js', { updates: plan.updates, attributes: { [optOutKey]: attributeValue } });
            changed = Object.keys(plan.updates).length > 0;
          }
          if (plan.add) { await request('/add.js', { items: [plan.add] }); changed = true; }
          let finalCart = changed ? await request('.js') : cart;
          const gift = finalCart.items.find(item => item.variant_id === plan.chosen && item.final_line_price === 0);
          if (plan.chosen && !gift) {
            const paidManaged = finalCart.items.filter(item => giftIds.includes(item.variant_id) && item.properties && item.properties._trd_gift_for);
            if (paidManaged.length) await request('/update.js', { updates: Object.fromEntries(paidManaged.map(item => [item.key, 0])) });
            throw new Error(root.dataset.error);
          }
          const systemIds = new Set(Object.values(eligibility).flat());
          let staleSystem = finalCart.items.find(item => systemIds.has(item.variant_id) && item.properties?.['Free gift']);
          while (staleSystem) {
            const properties = { ...staleSystem.properties, _trd_yarbo_gift_note_migrated: '1' };
            delete properties['Free gift'];
            finalCart = await request('/change.js', { id: staleSystem.key, quantity: staleSystem.quantity, properties });
            if (finalCart.items.some(item => item.key === staleSystem.key && item.properties?.['Free gift'])) throw new Error(root.dataset.error);
            changed = true;
            staleSystem = finalCart.items.find(item => systemIds.has(item.variant_id) && item.properties?.['Free gift']);
          }
          needsReload = needsReload || changed;
          if (needsReload) {
            const note = form.querySelector('[name="note"]');
            if (note && note.value !== (finalCart.note || '')) await request('/update.js', { note: note.value });
            if (pendingPreference === undefined) window.location.reload();
            return false;
          }
          if (!plan.allowed.length) { root.hidden = true; return true; }
          root.removeAttribute('data-failed');
          status.textContent = plan.optedOut ? root.dataset.skipped : root.dataset.ready;
          root.querySelectorAll('input[name="trd_cart_gift_choice"]').forEach(input => input.checked = Number(input.value) === (plan.chosen || 0));
          return true;
        } catch (_) {
          root.setAttribute('data-failed', '');
          status.textContent = root.dataset.error;
          retry.hidden = false;
          return false;
        } finally {
          root.removeAttribute('aria-busy');
          form.removeAttribute('data-trd-cart-checking');
          checkoutButtons.forEach((button, index) => button.disabled = disabledBefore[index]);
          giftInputs.forEach(input => input.disabled = false);
          running = null;
          if (pendingPreference !== undefined) {
            const next = pendingPreference;
            pendingPreference = undefined;
            queueMicrotask(() => reconcile(next));
          }
        }
      })();
      return running;
    };
    root.addEventListener('change', event => {
      if (event.target.matches('input[name="trd_cart_gift_choice"]')) reconcile(Number(event.target.value));
    });
    retry.addEventListener('click', () => reconcile());
    const declineGift = event => {
      const row = event.target.closest('[data-cartitem]');
      if (!row || !giftIds.includes(Number(row.dataset.cartitemId))) return;
      const isRemove = event.type === 'click' && event.target.closest('[data-cartitem-remove]');
      const isZero = event.type === 'change' && event.target.matches('[data-quantity-input]') && event.target.value !== '' && Number(event.target.value) === 0;
      if (!isRemove && !isZero) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      reconcile(0);
    };
    document.addEventListener('click', declineGift, true);
    document.addEventListener('change', declineGift, true);
    const guardCheckout = async event => {
      if (allowCheckout) return;
      const button = event.type === 'click' ? event.target.closest('button[name="checkout"]') : event.submitter;
      if (!button || button.form !== form || button.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (await reconcile()) { allowCheckout = true; form.requestSubmit(button); }
    };
    document.addEventListener('click', guardCheckout, true);
    document.addEventListener('submit', guardCheckout, true);
    const cartItems = form.querySelector('.cartitems--container');
    if (cartItems) new MutationObserver(() => {
      clearTimeout(queued);
      queued = setTimeout(() => reconcile(), 250);
    }).observe(cartItems, { childList: true, subtree: true });
    reconcile();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-yarbo-gift"] && !Shopify.designMode) return;
  try {
    if (!window.trdYarboGiftSubmitInstalled) {
    window.trdYarboGiftSubmitInstalled = true;
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const offer = form.querySelector('[data-trd-gift]');
      if (!offer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.trdGiftBusy === 'true') return;
      const chosen = offer.querySelector('input[name="trd_gift_choice"]:checked, input[type="hidden"][name="trd_gift_choice"]');
      const error = offer.querySelector('[role="alert"]');
      const data = new FormData(form);
      const quantity = Number(data.get('quantity') || 1);
      const mainId = Number(data.get('id'));
      if (!chosen || !mainId || !Number.isInteger(quantity) || quantity < 1) {
        error.textContent = offer.dataset.error;
        error.hidden = false;
        return;
      }
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      const main = { id: mainId, quantity, properties };
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      const gift = { id: Number(chosen.value), quantity, properties: { '_trd_gift_for': String(mainId) } };
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const disabledBefore = buttons.map(button => button.disabled);
      form.dataset.trdGiftBusy = 'true';
      form.setAttribute('aria-busy', 'true');
      buttons.forEach(button => button.disabled = true);
      error.hidden = true;
      try {
        if (Date.now() > Date.parse('2026-12-01T04:59:59Z')) throw new Error(offer.dataset.expired);
        const cartResponse = await fetch(`${offer.dataset.cartUrl}.js`, { headers: { 'Accept': 'application/json' } });
        if (!cartResponse.ok) throw new Error(offer.dataset.error);
        const cart = await cartResponse.json();
        const giftIds = [50382698741974, 50382700085462];
        const existingGifts = cart.items.filter(item => giftIds.includes(item.variant_id) && item.properties && item.properties._trd_gift_for);
        const eligibility = {
  "50382698741974": [
    47259631845590,
    47259647410390,
    48360806580438,
    48360810938582,
    50409005121750,
    50409143730390,
    50409143828694,
    50409143861462,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ],
  "50382700085462": [
    47259649442006,
    48360804450518,
    48360806744278,
    48360811528406,
    50409005482198,
    50409005973718,
    50409143795926,
    50409145041110,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ]
};
        const systemIds = [...cart.items.map(item => item.variant_id), mainId];
        const keepGift = existingGifts.find(item => eligibility[item.variant_id].some(id => systemIds.includes(id)));
        const updates = {};
        existingGifts.forEach(item => {
          const wanted = item === keepGift ? 1 : 0;
          if (item.quantity !== wanted) updates[item.key] = wanted;
        });
        if (Object.keys(updates).length || (cart.attributes && cart.attributes._trd_yarbo_gift_opt_out)) {
          const updateResponse = await fetch(`${offer.dataset.cartUrl}/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates, attributes: { _trd_yarbo_gift_opt_out: '' } })
          });
          if (!updateResponse.ok) throw new Error(offer.dataset.error);
        }
        gift.quantity = 1;
        const extras = [...form.querySelectorAll('trd-accessory-kit [data-extra]:checked:not(:disabled)')]
          .map(input => ({ id: Number(input.value), quantity: 1 }))
          .filter(item => Number.isSafeInteger(item.id) && item.id > 0 && item.id !== mainId && !giftIds.includes(item.id));
        const items = [...(keepGift ? [main] : [main, gift]), ...extras];
        if (keepGift) delete main.properties['Free gift'];
        const response = await fetch(`${offer.dataset.cartUrl}/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || offer.dataset.error);
        window.location.assign(offer.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || offer.dataset.error;
        error.hidden = false;
        error.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } finally {
        form.dataset.trdGiftBusy = 'false';
        form.removeAttribute('aria-busy');
        buttons.forEach((button, index) => button.disabled = disabledBefore[index]);
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
